export default "__VITE_ASSET__BFmSDsAq__"